import { forwardRef } from "react";
import { InputMask, type InputMaskProps } from "@react-input/mask";

export const CNPJMask = forwardRef<HTMLInputElement, InputMaskProps>(
  function CNPJMask(props, ref) {
    const { ...other } = props;
    return (
      <InputMask
        ref={ref}
        mask="__.___.___/____-__"
        replacement={{ _: /\d/ }}
        {...other}
      />
    );
  }
);